import {
    overquotaNewFullBlocked,
    overquotaNewFullBlockedModal,
} from 'reactApp/appHelpers/featuresHelpers/features/overquotaNewFullBlocked';
import { overquotaUseQuotaForProfileApi } from 'reactApp/appHelpers/featuresHelpers/features/overquotaUseProfileApiAndQuota';
import {
    overStatesCheckedByQuota,
    overStatesCheckedByQuotaNew,
} from 'reactApp/appHelpers/featuresHelpers/features/overStatesCheckedByQuota';
import { getUserOverquotaState } from 'reactApp/modules/profile/profile.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import type { RootState } from 'reactApp/store';
import { createSelector } from 'reselect';
import type { quotaStates } from 'server/types/context/IUser';

const backOverquotaStates: quotaStates[] = ['started', 'blocked', 'unblocked', 'cleared', 'after_clear'];

if (overquotaNewFullBlocked || overquotaNewFullBlockedModal) {
    backOverquotaStates.push('full_blocked');
}

export const getOverquotaFromProfileApi = (state: quotaStates | undefined, isOverQuota: boolean) => {
    let isOverquotaFromProfileApi = state ? backOverquotaStates.includes(state) : false;
    if (isOverquotaFromProfileApi && state && overStatesCheckedByQuota.includes(state) && overquotaUseQuotaForProfileApi && !isOverQuota) {
        // Юзер не в оверквоте, но бек скорее всего еще не обработал состояние после удаления файлов юзером
        isOverquotaFromProfileApi = false;
    }
    return isOverquotaFromProfileApi;
};

export const isUserOverquotaFromApi = createSelector(UserQuotaSelectors.isOverquota, getUserOverquotaState, (isOverquota, quotaState) => {
    return getOverquotaFromProfileApi(quotaState?.state, isOverquota);
});

const backOverquotaStatesNew: quotaStates[] = [...backOverquotaStates, 'full_blocked'];

// Новый флоу определения оверквотера (выкидываем учет фичи overquotaNewFullBlocked. Просто выкинуть пока не можем)
// Используйте, если нужно также учитывать стейт full_blocked без фичи overquotaNewFullBlocked
export const isUserOverquotaAndFromApiNew = createSelector(
    UserQuotaSelectors.isOverquota,
    getUserOverquotaState,
    (isOverquota, quotaState) => {
        let isOverquotaFromProfileApi = quotaState?.state ? backOverquotaStatesNew.includes(quotaState?.state) : false;
        if (
            isOverquotaFromProfileApi &&
            quotaState?.state &&
            overStatesCheckedByQuotaNew.includes(quotaState?.state) &&
            overquotaUseQuotaForProfileApi &&
            !isOverquota
        ) {
            // Юзер не в оверквоте, но бек скорее всего еще не обработал состояние после удаления файлов юзером
            isOverquotaFromProfileApi = false;
        }
        return isOverquotaFromProfileApi;
    }
);

export const isCloudOrMailOrApiOverQuota = createSelector(
    [
        (state: RootState) => UserSelectors.isOverQuotaUser(state),
        (state: RootState) => isUserOverquotaAndFromApiNew(state),
        (state: RootState) => UserQuotaSelectors.isOverquota(state),
    ],
    (isOverQuotaCloud, isOverquotaFromProfileApi, isOverQuotaMailAndCloud) =>
        isOverQuotaCloud || isOverquotaFromProfileApi || isOverQuotaMailAndCloud
);
